import { render, staticRenderFns } from "./new_comercial.vue?vue&type=template&id=5cff17d8&"
import script from "./new_comercial.vue?vue&type=script&lang=js&"
export * from "./new_comercial.vue?vue&type=script&lang=js&"
import style0 from "./new_comercial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5cff17d8', component.options)
    } else {
      api.reload('5cff17d8', component.options)
    }
    module.hot.accept("./new_comercial.vue?vue&type=template&id=5cff17d8&", function () {
      api.rerender('5cff17d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Map/Details/new_comercial.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Map/Details/new_comercial.vue
// module id = 87wr
// module chunks = 0